import { render, staticRenderFns } from "./check-box.vue?vue&type=template&id=0575c002&scoped=true"
import script from "./check-box.vue?vue&type=script&lang=js"
export * from "./check-box.vue?vue&type=script&lang=js"
import style0 from "./check-box.vue?vue&type=style&index=0&id=0575c002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0575c002",
  null
  
)

export default component.exports